// src/pages/Categories.js
import React from "react";
import { Link } from "react-router-dom";

const CATEGORIES = [
  // Nature
  { slug: "nature-wallpaper",        label: "Nature",          emoji: "🌿", desc: "Free HD nature wallpapers — forests, mountains, flowers",    color: "#2d6a4f" },
  { slug: "mountain-wallpaper",      label: "Mountains",       emoji: "⛰️",  desc: "4K mountain wallpapers free download",                       color: "#4a5568" },
  { slug: "beach-wallpaper",         label: "Beach & Ocean",   emoji: "🌊", desc: "HD beach and ocean wallpapers free",                          color: "#1a6fb5" },
  { slug: "sunset-wallpaper",        label: "Sunset",          emoji: "🌅", desc: "Beautiful sunset wallpapers in 4K",                           color: "#c05621" },
  { slug: "forest-wallpaper",        label: "Forest",          emoji: "🌲", desc: "HD forest wallpapers free download",                          color: "#276749" },
  { slug: "flower-wallpaper",        label: "Flowers",         emoji: "🌸", desc: "Beautiful flower wallpapers and stock photos",                color: "#b83280" },

  // City & Architecture
  { slug: "city-wallpaper",          label: "City",            emoji: "🌆", desc: "City skyline HD wallpapers free download",                    color: "#2b4c7e" },
  { slug: "architecture-wallpaper",  label: "Architecture",    emoji: "🏛️",  desc: "Architecture photography free stock photos",                  color: "#744210" },
  { slug: "night-city-wallpaper",    label: "Night City",      emoji: "🌃", desc: "Night city lights 4K wallpapers free",                        color: "#1a202c" },

  // Abstract & Art
  { slug: "abstract-wallpaper",      label: "Abstract",        emoji: "🎨", desc: "Abstract art HD wallpapers free download",                    color: "#553c9a" },
  { slug: "dark-wallpaper",          label: "Dark",            emoji: "🖤", desc: "Dark HD wallpapers for desktop and mobile",                   color: "#1a202c" },
  { slug: "minimal-wallpaper",       label: "Minimal",         emoji: "⬜", desc: "Minimalist wallpapers free download HD",                      color: "#718096" },
  { slug: "aesthetic-wallpaper",     label: "Aesthetic",       emoji: "✨", desc: "Aesthetic wallpapers HD free for iPhone Android",             color: "#9f7aea" },
  { slug: "galaxy-wallpaper",        label: "Galaxy & Space",  emoji: "🌌", desc: "Galaxy space 4K wallpapers free download",                   color: "#2d3748" },

  // Lifestyle
  { slug: "food-photography",        label: "Food",            emoji: "🍕", desc: "Free food photography stock photos",                          color: "#c05621" },
  { slug: "travel-photography",      label: "Travel",          emoji: "✈️",  desc: "Free travel photography stock photos HD",                    color: "#2b6cb0" },
  { slug: "fashion-photography",     label: "Fashion",         emoji: "👗", desc: "Free fashion photography stock photos",                       color: "#b83280" },
  { slug: "business-photos",         label: "Business",        emoji: "💼", desc: "Free business stock photos for websites",                     color: "#2d3748" },
  { slug: "technology-photos",       label: "Technology",      emoji: "💻", desc: "Free technology stock photos HD",                             color: "#2b6cb0" },
  { slug: "people-photography",      label: "People",          emoji: "👥", desc: "Free people and portrait stock photos",                       color: "#744210" },

  // Mobile Wallpapers
  { slug: "iphone-wallpaper",        label: "iPhone Wallpaper",emoji: "📱", desc: "Free iPhone wallpapers HD download 2026",                     color: "#1a202c" },
  { slug: "android-wallpaper",       label: "Android Wallpaper",emoji: "📲",desc: "Free Android wallpapers HD download",                         color: "#276749" },
  { slug: "4k-wallpaper",            label: "4K Wallpapers",   emoji: "🔲", desc: "Free 4K ultra HD wallpapers download",                        color: "#553c9a" },

  // Special
  { slug: "anime-wallpaper",         label: "Anime",           emoji: "🎌", desc: "Free anime wallpapers HD download",                           color: "#b83280" },
  { slug: "gaming-wallpaper",        label: "Gaming",          emoji: "🎮", desc: "Free gaming wallpapers HD 4K download",                       color: "#1a202c" },
  { slug: "christmas-wallpaper",     label: "Christmas",       emoji: "🎄", desc: "Free Christmas wallpapers HD download",                       color: "#276749" },
];

const Categories = () => (
  <div className="page">
    <div className="container">
      <div className="cat-header">
        <div className="hero__badge">Browse by Category</div>
        <h1 className="cat-title">
          Free HD Wallpapers &<br />
          <span className="hero__accent">Stock Photos by Category</span>
        </h1>
        <p className="cat-sub">
          Browse millions of free wallpapers and stock photos by category.
          Download in 4K quality — no watermark, no signup required.
        </p>
      </div>

      <div className="cat-grid">
        {CATEGORIES.map(cat => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="cat-card"
            style={{ "--cat-color": cat.color }}
          >
            <span className="cat-card__emoji">{cat.emoji}</span>
            <h2 className="cat-card__label">{cat.label}</h2>
            <p className="cat-card__desc">{cat.desc}</p>
            <span className="cat-card__arrow">→</span>
          </Link>
        ))}
      </div>

      {/* SEO text */}
      <div className="seo-section">
        <h2 className="seo-section__title">
          Free HD Wallpapers & Stock Photos — All Categories
        </h2>
        <div className="seo-section__grid">
          <div className="seo-card">
            <span className="seo-card__icon">🖼</span>
            <h3>4K HD Wallpapers</h3>
            <p>Download ultra high resolution 4K wallpapers for desktop, laptop, iPhone and Android. Nature, city, abstract, anime and more — all free.</p>
          </div>
          <div className="seo-card">
            <span className="seo-card__icon">📸</span>
            <h3>Stock Photos Free</h3>
            <p>Professional stock photos for blogs, websites, social media and commercial use. No attribution required. Thousands of new photos daily.</p>
          </div>
          <div className="seo-card">
            <span className="seo-card__icon">📱</span>
            <h3>Mobile Wallpapers</h3>
            <p>Beautiful wallpapers perfectly sized for iPhone and Android phones. Portrait orientation, high quality, free download instantly.</p>
          </div>
          <div className="seo-card">
            <span className="seo-card__icon">⚡</span>
            <h3>Instant Free Download</h3>
            <p>No signup needed. No watermarks. Download any photo in original quality. Multiple sizes available — Original, Large, Medium, Small.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Categories;
export { CATEGORIES };
